/* eslint-disable */
require('./abi')
require('./abiprufung')
require('./abitur-exam')
require('./arrow')
require('./arrow-curved')
require('./burger')
require('./calendar')
require('./cart')
require('./central-audit')
require('./class-work')
require('./courses-1')
require('./courses-2')
require('./crash-course')
require('./ellipse')
require('./faq')
require('./hat')
require('./help-center')
require('./hero-1')
require('./hero-2')
require('./hours')
require('./ico-fb')
require('./ico-in')
require('./ico-inst')
require('./ico-tw')
require('./ico-you')
require('./instagram')
require('./logo')
require('./mail')
require('./offers')
require('./password')
require('./phone')
require('./pin')
require('./products')
require('./quotes-large')
require('./quotes')
require('./reload')
require('./search')
require('./uni')
require('./zap')
